"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = createClient;
const crypto_1 = require("crypto");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const IccfProofTxMaterialBuilder_1 = require("../ICCF/IccfProofTxMaterialBuilder");
const logger = __importStar(require("../logger"));
const formatter_1 = require("../formatter");
const serialization_1 = require("../gtx/serialization");
const gtxTool = __importStar(require("../gtx/gtx"));
const utils_1 = require("./utils");
const promiEvents_1 = require("../promiEvent/promiEvents");
const errors_1 = require("../gtx/errors");
const enums_1 = require("./enums");
const blockIdentifier_1 = require("./validation/blockIdentifier");
const networkSettings_1 = require("./validation/networkSettings");
const signMethod_1 = require("./validation/signMethod");
const txRid_1 = require("./validation/txRid");
const anchoringTransaction_1 = require("./validation/anchoringTransaction");
const requests_1 = require("./validation/requests");
const utils_2 = require("../ICCF/utils");
const requestWithFailoverStrategy_1 = require("./requestWithFailoverStrategy");
const transactionStatusReponse_1 = require("./validation/transactionStatusReponse");
function createClient(settings) {
    return __awaiter(this, void 0, void 0, function* () {
        (0, networkSettings_1.isNetworkSettingValid)(settings, { throwOnError: true });
        const config = yield (0, utils_1.getClientConfigFromSettings)(settings);
        config.merkleHashVersion = yield getMerkleHashVersion(settings);
        return {
            config,
            query(nameOrQueryObject, args, callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    let _name, _args;
                    if (typeof nameOrQueryObject === "string") {
                        _name = nameOrQueryObject;
                        _args = args;
                    }
                    else {
                        _name = nameOrQueryObject === null || nameOrQueryObject === void 0 ? void 0 : nameOrQueryObject.name;
                        _args = nameOrQueryObject === null || nameOrQueryObject === void 0 ? void 0 : nameOrQueryObject.args;
                    }
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.POST, `query_gtv/${config.blockchainRid}`, config, (0, serialization_1.encodeValue)((0, formatter_1.toQueryObjectGTV)(_name, _args)));
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handlePostResponse)(error, statusCode, (0, requests_1.isRawGtv)(rspBody), (0, utils_1.callbackPromiseBuilder)(reject, resolve, callback));
                    });
                });
            },
            signTransaction(transaction, signMethod, callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    logger.debug(`Signing transaction with ${!(0, utils_1.isKeyPair)(signMethod) ? "signature provider containing " : ""}pubKey: ${(0, formatter_1.toString)(signMethod.pubKey)}`);
                    const gtx = (0, utils_1.getGTXFromBufferOrTransactionOrOperation)(transaction, config.blockchainRid);
                    try {
                        const signedTx = yield ((0, utils_1.isKeyPair)(signMethod)
                            ? gtxTool.sign(gtx, signMethod.privKey, config.merkleHashVersion, signMethod.pubKey)
                            : gtxTool.sign(gtx, signMethod, config.merkleHashVersion));
                        const gtxBytes = (0, utils_1.getSerializedGTX)(signedTx);
                        if (typeof callback === "function") {
                            callback(null, gtxBytes);
                        }
                        return gtxBytes;
                    }
                    catch (error) {
                        if (typeof callback === "function") {
                            callback(error, null);
                        }
                        // Todo the error should be replaced with the custom error MissingSignerException
                        throw new Error(error);
                    }
                });
            },
            sendTransactionWithRetries(transaction, callback, confirmationLevel = enums_1.ChainConfirmationLevel.Dapp) {
                const client = this;
                function sendOnce() {
                    return client.sendTransaction(transaction, true, callback, confirmationLevel);
                }
                const promiEvent = new promiEvents_1.Web3PromiEvent((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    let error = null;
                    // await sleep(1000);
                    for (let i = 0; i < config.retryTransactionPolling.count; i++) {
                        logger.info(`sendTransactionWithRetries attempt ${i + 1} of ${config.retryTransactionPolling.count}`);
                        const tmpPromiEvent = sendOnce()
                            .on(enums_1.TransactionEvent.ClusterAnchoringConfirmation, receipt => {
                            promiEvent.emit(enums_1.TransactionEvent.ClusterAnchoringConfirmation, receipt);
                        })
                            .on(enums_1.TransactionEvent.SystemAnchoringConfirmation, receipt => {
                            promiEvent.emit(enums_1.TransactionEvent.SystemAnchoringConfirmation, receipt);
                        })
                            .on(enums_1.TransactionEvent.DappReceived, receipt => {
                            promiEvent.emit(enums_1.TransactionEvent.DappReceived, receipt);
                        })
                            .on(enums_1.TransactionEvent.Signed, receipt => {
                            promiEvent.emit(enums_1.TransactionEvent.Signed, receipt);
                        })
                            .on(enums_1.TransactionEvent.DappConfirmed, receipt => {
                            promiEvent.emit(enums_1.TransactionEvent.DappConfirmed, receipt);
                        })
                            .catch(tmpError => {
                            logger.warning(`sendTransactionWithRetries error on attempt ${i + 1} of ${config.retryTransactionPolling.count}: ${tmpError}`);
                            promiEvent.emit(enums_1.TransactionEvent.Rejected, tmpError);
                            error = tmpError;
                        });
                        const tmpReceipt = yield tmpPromiEvent;
                        if (tmpReceipt) {
                            resolve(tmpReceipt);
                            return;
                        }
                        yield (0, utils_1.sleep)(config.retryTransactionPolling.interval);
                    }
                    reject(error);
                }));
                return promiEvent;
            },
            sendTransaction(transaction, doStatusPolling = true, callback, confirmationLevel = enums_1.ChainConfirmationLevel.Dapp) {
                const promiEvent = new promiEvents_1.Web3PromiEvent((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    try {
                        const gtx = (0, utils_1.getGTXFromBufferOrTransactionOrOperation)(transaction, config.blockchainRid);
                        if (gtx.signers.length !== ((_a = gtx.signatures) === null || _a === void 0 ? void 0 : _a.length)) {
                            reject(new errors_1.NumberOfSignersAndSignaturesException());
                        }
                        const gtxBytes = (0, utils_1.getSerializedGTX)(gtx);
                        const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.POST, `tx/${config.blockchainRid}`, config, gtxBytes);
                        const transactionRid = gtxTool.getDigestToSign(gtx, config.merkleHashVersion);
                        try {
                            yield (0, utils_1.handlePostResponsePromisified)(error, statusCode, (0, requests_1.isRawGtv)(rspBody));
                            if (typeof callback === "function") {
                                callback(null, {
                                    status: enums_1.ResponseStatus.Waiting,
                                    statusCode,
                                    transactionRid: transactionRid,
                                    node: (_b = config.nodeManager.lastUsedNode) === null || _b === void 0 ? void 0 : _b.url,
                                });
                            }
                        }
                        catch (_error) {
                            if (typeof callback === "function") {
                                callback(_error, null);
                            }
                            return reject(_error);
                        }
                        const client = this;
                        const statusPollingConfig = {
                            dappStatusPolling: client.config.dappStatusPolling,
                            clusterAnchoringStatusPolling: client.config.clusterAnchoringStatusPolling,
                            systemAnchoringStatusPolling: client.config.systemAnchoringStatusPolling,
                        };
                        const stickyNodeClient = yield createStickyNodeClient(client); //to avoid false rejections by oblivious nodes
                        let transactionReceipt = yield (0, utils_1.handleDappConfirmations)(transactionRid, doStatusPolling, confirmationLevel, promiEvent, statusPollingConfig.dappStatusPolling, () => stickyNodeClient.getTransactionStatus(transactionRid, callback), stickyNodeClient);
                        if (confirmationLevel === enums_1.ChainConfirmationLevel.None ||
                            confirmationLevel === enums_1.ChainConfirmationLevel.Dapp) {
                            resolve(transactionReceipt);
                            return;
                        }
                        const { anchoringClient, systemAnchoringChainBridString } = yield (0, utils_1.getAnchoringClientAndSystemChainRid)(client);
                        transactionReceipt = yield (0, utils_1.handleSystemConfirmations)(transactionReceipt, confirmationLevel, promiEvent, statusPollingConfig, anchoringClient, systemAnchoringChainBridString, () => stickyNodeClient.getClusterAnchoringTransactionConfirmation(transactionRid, anchoringClient, callback), anchoredTxRid => stickyNodeClient.getSystemAnchoringTransactionConfirmation(anchoredTxRid, anchoringClient, systemAnchoringChainBridString, callback));
                        resolve(transactionReceipt);
                    }
                    catch (error) {
                        callback === null || callback === void 0 ? void 0 : callback(error, null);
                        reject(error);
                    }
                }));
                return promiEvent;
            },
            signAndSendUniqueTransaction(transactionOrOperation, signMethod, doStatusPolling = true, callback, confirmationLevel = enums_1.ChainConfirmationLevel.Dapp) {
                (0, signMethod_1.isSignMethodValid)(signMethod, { throwOnError: true });
                const promiEvent = new promiEvents_1.Web3PromiEvent((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    const client = this;
                    const transaction = "name" in transactionOrOperation
                        ? {
                            operations: [transactionOrOperation],
                            signers: [signMethod.pubKey],
                        }
                        : transactionOrOperation;
                    const hasNop = transaction.operations.some(operation => {
                        return operation.name === "nop";
                    });
                    const transactionWithNop = hasNop ? transaction : client.addNop(transaction);
                    try {
                        const signedTx = yield client.signTransaction(transactionWithNop, signMethod);
                        promiEvent.emit(enums_1.TransactionEvent.Signed, signedTx);
                        const sendTransactionPromiEvent = client.sendTransaction(signedTx, doStatusPolling, callback, confirmationLevel);
                        (0, utils_1.linkPromiEvents)(sendTransactionPromiEvent, promiEvent);
                        resolve(yield sendTransactionPromiEvent);
                    }
                    catch (error) {
                        reject(error);
                    }
                }));
                return promiEvent;
            },
            getTransaction(transactionRid, callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        (0, txRid_1.isTxRidValid)(transactionRid, { throwOnError: true });
                    }
                    catch (error) {
                        callback === null || callback === void 0 ? void 0 : callback(error, null);
                        throw error;
                    }
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `tx/${config.blockchainRid}/${(0, formatter_1.ensureString)(transactionRid)}`, config);
                    const transaction = (0, requests_1.isTransaction)(rspBody);
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, statusCode === 200 && transaction ? (0, formatter_1.toBuffer)(transaction.tx) : (0, requests_1.isRawGtv)(rspBody), (0, utils_1.callbackPromiseBuilder)(reject, resolve, callback));
                    });
                });
            },
            getTransactionStatus(transactionRid, callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        (0, txRid_1.isTxRidValid)(transactionRid, { throwOnError: true });
                    }
                    catch (error) {
                        callback === null || callback === void 0 ? void 0 : callback(error, null);
                        throw error;
                    }
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `tx/${config.blockchainRid}/${transactionRid.toString("hex")}/status`, config);
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, (0, requests_1.isRawGtv)(rspBody), (0, utils_1.callbackPromiseBuilder)(reject, result => resolve((0, transactionStatusReponse_1.validateTransactionStatusReponse)({
                            statusCode,
                            result,
                        })), callback));
                    });
                });
            },
            addNop(transaction) {
                const _transaction = (0, cloneDeep_1.default)(transaction);
                const noOperation = {
                    name: "nop",
                    args: [(0, crypto_1.randomBytes)(32)],
                };
                _transaction.operations = [..._transaction.operations, noOperation];
                return _transaction;
            },
            getTransactionsInfo() {
                return __awaiter(this, arguments, void 0, function* (limit = 25, beforeTime, callback, afterTime, signerPubKey) {
                    const beforeTimeQueryParam = beforeTime ? `&before-time=${beforeTime.getTime()}` : "";
                    const afterTimeQueryParam = afterTime ? `&after-time=${afterTime.getTime()}` : "";
                    const signerQueryParam = signerPubKey ? `&signer=${signerPubKey}` : "";
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `transactions/${config.blockchainRid}?limit=${limit}${beforeTimeQueryParam}${afterTimeQueryParam}${signerQueryParam}`, config);
                    const transactionsInfoResponseArray = (0, requests_1.isTransactionInfoResponseArray)(rspBody);
                    const body = statusCode === 200 && transactionsInfoResponseArray
                        ? transactionsInfoResponseArray.map(utils_1.formatTransactionInfoResponse)
                        : rspBody;
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, (0, requests_1.isRawGtv)(body), (0, utils_1.callbackPromiseBuilder)(reject, resolve, callback));
                    });
                });
            },
            getTransactionInfo(transactionRid, callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        (0, txRid_1.isTxRidValid)(transactionRid, { throwOnError: true });
                    }
                    catch (error) {
                        callback === null || callback === void 0 ? void 0 : callback(error, null);
                        throw error;
                    }
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `transactions/${config.blockchainRid}/${(0, formatter_1.ensureString)(transactionRid)}`, config);
                    const transactionInfoResponse = (0, requests_1.isTransactionInfoResponse)(rspBody);
                    const body = statusCode === 200 && transactionInfoResponse
                        ? (0, utils_1.formatTransactionInfoResponse)(transactionInfoResponse)
                        : rspBody;
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, (0, requests_1.isRawGtv)(body), (0, utils_1.callbackPromiseBuilder)(reject, resolve, callback));
                    });
                });
            },
            getAnchoringStatusForBlockRid(blockRid, anchoringClient, systemAnchoringChainRid) {
                return __awaiter(this, void 0, void 0, function* () {
                    const client = this;
                    const result = { status: enums_1.AnchoringStatus.NotAnchored };
                    const clusterAnchoredTx = yield (0, utils_2.awaitGetAnchoringTransactionForBlockRid)(anchoringClient, (0, formatter_1.ensureBuffer)(client.config.blockchainRid), (0, formatter_1.ensureBuffer)(blockRid), config.clusterAnchoringStatusPolling);
                    if (!clusterAnchoredTx) {
                        return result;
                    }
                    const anchoringTransactionValidation = anchoringTransaction_1.AnchoringTransactionSchema.safeParse(clusterAnchoredTx);
                    if (!anchoringTransactionValidation.success) {
                        return result;
                    }
                    result.status = enums_1.AnchoringStatus.ClusterAnchored;
                    result.clusterAnchoredTx = anchoringTransactionValidation.data;
                    const systemAnchoredTransaction = yield (0, utils_1.getSystemAnchoringTransaction)(config.endpointPool, anchoringTransactionValidation.data.txRid, anchoringClient, systemAnchoringChainRid, config.systemAnchoringStatusPolling, config.merkleHashVersion);
                    if (!systemAnchoredTransaction) {
                        return result;
                    }
                    result.status = enums_1.AnchoringStatus.SystemAnchored;
                    result.systemAnchoredTx = systemAnchoredTransaction;
                    return result;
                });
            },
            getTransactionConfirmationLevel(transactionRid, callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    try {
                        const client = this;
                        const dappConfirmation = yield client.getTransactionStatus(transactionRid);
                        const response = {
                            status: dappConfirmation.status,
                            statusCode: dappConfirmation.statusCode,
                            transactionRid: (0, formatter_1.ensureBuffer)(transactionRid),
                            node: (_a = client.config.nodeManager.lastUsedNode) === null || _a === void 0 ? void 0 : _a.url,
                        };
                        if (dappConfirmation.status === enums_1.ResponseStatus.Waiting) {
                            return response;
                        }
                        let clusterAnchoringResult = null;
                        if (dappConfirmation.status === enums_1.ResponseStatus.Confirmed) {
                            const { anchoringClient, systemAnchoringChainBridString } = yield (0, utils_1.getAnchoringClientAndSystemChainRid)(client);
                            clusterAnchoringResult = yield client.getClusterAnchoringTransactionConfirmation(transactionRid, anchoringClient);
                            if (clusterAnchoringResult === enums_1.AnchoringStatus.NotAnchored || !clusterAnchoringResult) {
                                return response;
                            }
                            if (clusterAnchoringResult === enums_1.AnchoringStatus.FailedAnchoring) {
                                response.status = enums_1.AnchoringStatus.FailedAnchoring;
                                response.statusCode = 400;
                                return response;
                            }
                            const anchoringTransactionValidation = anchoringTransaction_1.AnchoringTransactionSchema.safeParse(clusterAnchoringResult);
                            if (!anchoringTransactionValidation.success) {
                                return response;
                            }
                            if (anchoringTransactionValidation.success) {
                                response.status = enums_1.AnchoringStatus.ClusterAnchored;
                                response.statusCode = 200;
                                response.clusterAnchoredTx = anchoringTransactionValidation.data;
                                response.clusterAnchoringClientBrid = anchoringClient.config.blockchainRid;
                                const systemAnchoringResult = yield client.getSystemAnchoringTransactionConfirmation(anchoringTransactionValidation.data.txRid, anchoringClient, systemAnchoringChainBridString);
                                if (!systemAnchoringResult) {
                                    return response;
                                }
                                response.status = enums_1.AnchoringStatus.SystemAnchored;
                                response.systemAnchoredTx = systemAnchoringResult;
                                response.systemAnchoringClientBrid = systemAnchoringChainBridString;
                                return response;
                            }
                        }
                        return response;
                    }
                    catch (error) {
                        callback === null || callback === void 0 ? void 0 : callback(error, null);
                        throw error;
                    }
                });
            },
            getTransactionCount(callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `transactions/${config.blockchainRid}/count`, config, undefined, true);
                    const transactionsCount = (0, requests_1.isTransactionsCount)(rspBody);
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, statusCode === 200 ? transactionsCount === null || transactionsCount === void 0 ? void 0 : transactionsCount.transactionsCount : (0, requests_1.isRawGtv)(rspBody), (0, utils_1.callbackPromiseBuilder)(reject, resolve, callback));
                    });
                });
            },
            getBlockInfo(blockIdentifier_2) {
                return __awaiter(this, arguments, void 0, function* (blockIdentifier, txs = false, callback) {
                    (0, blockIdentifier_1.isBlockIdentifierValid)(blockIdentifier, { throwOnError: true });
                    const queryString = typeof blockIdentifier === "string" ? blockIdentifier : `height/${blockIdentifier}`;
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `blocks/${config.blockchainRid}/${queryString}?txs=${txs}`, config);
                    const blockInfoResponse = (0, requests_1.isBlockInfoResponse)(rspBody);
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, statusCode === 200 && blockInfoResponse !== null && blockInfoResponse
                            ? (0, utils_1.formatBlockInfoResponse)(blockInfoResponse)
                            : (0, requests_1.isRawGtv)(rspBody), (0, utils_1.callbackPromiseBuilder)(reject, resolve, callback));
                    });
                });
            },
            getLatestBlock() {
                return __awaiter(this, arguments, void 0, function* (txs = false, callback) {
                    const shouldIncludeFullTransaction = txs ? `&txs=${txs}` : "";
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `blocks/${config.blockchainRid}?limit=1${shouldIncludeFullTransaction}`, config, undefined, true);
                    const indexOfLatestBlock = 0;
                    const blockInfoResponseArray = (0, requests_1.isBlockInfoResponseArray)(rspBody);
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, statusCode === 200 && blockInfoResponseArray !== null && blockInfoResponseArray
                            ? (0, utils_1.formatBlockInfoResponse)(blockInfoResponseArray[indexOfLatestBlock])
                            : (0, requests_1.isRawGtv)(rspBody), (0, utils_1.callbackPromiseBuilder)(reject, resolve, callback));
                    });
                });
            },
            getBlocks() {
                return __awaiter(this, arguments, void 0, function* ({ limit, beforeTime, afterTime, beforeHeight, afterHeight, excludeEmpty, txs, callback, } = {}) {
                    const searchValues = {
                        limit,
                        txs,
                        "before-time": beforeTime,
                        "after-time": afterTime,
                        "before-height": beforeHeight,
                        "after-height": afterHeight,
                        "exclude-empty": excludeEmpty,
                    };
                    const searchParams = new URLSearchParams();
                    for (const [key, value] of Object.entries(searchValues)) {
                        if (value !== undefined) {
                            searchParams.append(key, value.toString());
                        }
                    }
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `blocks/${config.blockchainRid}?${searchParams}`, config);
                    const blockInfoResponseArray = (0, requests_1.isBlockInfoResponseArray)(rspBody);
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, statusCode === 200 && blockInfoResponseArray
                            ? blockInfoResponseArray.map(utils_1.formatBlockInfoResponse)
                            : (0, requests_1.isRawGtv)(rspBody), (0, utils_1.callbackPromiseBuilder)(reject, resolve, callback));
                    });
                });
            },
            getClientNodeUrlPool() {
                return config.endpointPool.map((endpoint) => endpoint.url);
            },
            /**
             * Retrieves a confirmation proof for a transaction with the specified sha256
             * hash.
             * @param txRid A buffer of 32 bytes
             * @param callback parameters (error, responseObjectProof) if first
             * parameter is not null, an error occurred.
             * If first parameter is null, then the second parameter is an object
             * like the following:
             *
             * {hash: messageHashBuffer,
             *  blockHeader: blockHeaderBuffer,
             *  signatures: [{pubKey: pubKeyBuffer, signature: sigBuffer}, ...],
             *  merklePath: [{side: <0|1>, hash: <hash buffer level n-1>},
             *               ...
             *               {side: <0|1>, hash: <hash buffer level 1>}]}
             *
             * If no such transaction RID exists, the callback will be called with (null, null).
             *
             * The proof object can be validated using
             * postchain-common.util.validateMerklePath(proof.merklePath, proof.hash,
             * proof.blockHeader.slice(32, 64))
             *
             * The signatures must be validated agains some know trusted source for valid signers
             * at this specific block height.
             */
            getConfirmationProof(txRid, callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        (0, txRid_1.isTxRidValid)(txRid, { throwOnError: true });
                    }
                    catch (error) {
                        callback === null || callback === void 0 ? void 0 : callback(error, null);
                        throw error;
                    }
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `tx/${config.blockchainRid}/${(0, formatter_1.ensureString)(txRid)}/confirmationProof`, config);
                    const confirmationProof = {
                        merkleProofTree: "",
                        txIndex: 0,
                    };
                    if (statusCode === 200) {
                        try {
                            const transactionConfirmationProof = (0, requests_1.isTransactionConfirmationProof)(rspBody);
                            if (!transactionConfirmationProof) {
                                throw error;
                            }
                            const decodedProof = (0, serialization_1.decodeValue)((0, formatter_1.toBuffer)(transactionConfirmationProof.proof));
                            confirmationProof.txIndex = decodedProof.txIndex;
                            confirmationProof.hash = decodedProof.hash;
                            confirmationProof.blockHeader = decodedProof.blockHeader;
                            confirmationProof.witness = decodedProof.witness;
                            confirmationProof.merkleProofTree = decodedProof.merkleProofTree;
                        }
                        catch (decodeError) {
                            if (callback) {
                                callback(decodeError, null);
                            }
                            throw decodeError;
                        }
                    }
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, statusCode === 200 ? confirmationProof : (0, requests_1.isRawGtv)(rspBody), (0, utils_1.callbackPromiseBuilder)(reject, resolve, callback));
                    });
                });
            },
            getClusterAnchoringTransactionConfirmation(transactionRid, anchoringClient, callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        (0, txRid_1.isTxRidValid)(transactionRid, { throwOnError: true });
                    }
                    catch (error) {
                        callback === null || callback === void 0 ? void 0 : callback(error, null);
                        throw error;
                    }
                    const client = this;
                    try {
                        let confirmationProof;
                        try {
                            confirmationProof = yield client.getConfirmationProof(transactionRid);
                        }
                        catch (error) {
                            callback === null || callback === void 0 ? void 0 : callback(error, null);
                            return enums_1.AnchoringStatus.NotAnchored;
                        }
                        const anchoringTransaction = yield (0, IccfProofTxMaterialBuilder_1.getBlockAnchoringTransaction)(client, anchoringClient, transactionRid, confirmationProof);
                        if (!anchoringTransaction)
                            return enums_1.AnchoringStatus.NotAnchored;
                        return anchoringTransaction;
                    }
                    catch (error) {
                        callback === null || callback === void 0 ? void 0 : callback(error, null);
                        return enums_1.AnchoringStatus.FailedAnchoring;
                    }
                });
            },
            getSystemAnchoringTransactionConfirmation(anchoredTxRid, anchoringClient, systemAnchoringChainRid, callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        (0, txRid_1.isTxRidValid)(anchoredTxRid, { throwOnError: true });
                    }
                    catch (error) {
                        callback === null || callback === void 0 ? void 0 : callback(error, null);
                        throw error;
                    }
                    const systemAnchoringTransactionTransaction = yield (0, utils_1.getSystemAnchoringTransaction)(config.endpointPool, anchoredTxRid, anchoringClient, systemAnchoringChainRid, config.systemAnchoringStatusPolling, config.merkleHashVersion);
                    return systemAnchoringTransactionTransaction;
                });
            },
            getWaitingTransactions(blockchainRid, callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `/tx/${(0, formatter_1.ensureString)(blockchainRid)}/waiting`, config);
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, (0, requests_1.isRawGtv)(rspBody), (0, utils_1.callbackPromiseBuilder)(reject, resolve, callback));
                    });
                });
            },
            getWaitingTransaction(blockchainRid, txRid, callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { error, statusCode, rspBody, transactionTimestamp } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `/tx/${(0, formatter_1.ensureString)(blockchainRid)}/waiting/${(0, formatter_1.ensureString)(txRid)}`, config);
                    const transaction = (0, requests_1.isTransaction)(rspBody);
                    const result = transaction ? (0, formatter_1.toBuffer)(transaction.tx) : (0, requests_1.isRawGtv)(rspBody);
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, result, (0, utils_1.callbackPromiseBuilder)(reject, txData => resolve({
                            txData: (0, requests_1.isRawGtv)(txData),
                            transactionTimestamp: Number(transactionTimestamp),
                        }), callback));
                    });
                });
            },
            getRejectedTransactions(blockchainRid, callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `/tx/${(0, formatter_1.ensureString)(blockchainRid)}/rejected`, config);
                    const rejectedTransactionsArray = (0, requests_1.isRejectedTransactionResponseArray)(rspBody);
                    const validResponseBody = statusCode === 200 && rejectedTransactionsArray
                        ? rejectedTransactionsArray.map(rejectedTransaction => (0, utils_1.formatRejectedTransactionFromResponse)(rejectedTransaction))
                        : rspBody;
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, (0, requests_1.isRawGtv)(validResponseBody), (0, utils_1.callbackPromiseBuilder)(reject, resolve, callback));
                    });
                });
            },
            /**
             * Get app structure. Returns list of app modules in JSON format
             * @param callback - leverages error-first pattern and called when promise resolves
             */
            getAppStructure(callback) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `/query/${config.blockchainRid}?type=rell.get_app_structure`, config);
                    return new Promise((resolve, reject) => {
                        (0, utils_1.handleGetResponse)(error, statusCode, (0, requests_1.isRawGtv)(rspBody), (0, utils_1.callbackPromiseBuilder)(reject, resolve, callback));
                    });
                });
            },
        };
        function getMerkleHashVersion(settings) {
            return __awaiter(this, void 0, void 0, function* () {
                let merkleHashVersion;
                if (settings.merkleHashVersion !== undefined) {
                    merkleHashVersion = settings.merkleHashVersion;
                }
                else {
                    merkleHashVersion = yield (0, utils_1.getMerkleHashVersionFromDapp)(config);
                }
                return merkleHashVersion;
            });
        }
        function createStickyNodeClient(client) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (!client.config.nodeManager.lastUsedNode) {
                    throw new Error("No last used node found; cannot create sticky node client");
                }
                const stickyNodeClient = yield createClient({
                    nodeUrlPool: (_a = client.config.nodeManager.lastUsedNode) === null || _a === void 0 ? void 0 : _a.url,
                    blockchainRid: client.config.blockchainRid,
                    merkleHashVersion: client.config.merkleHashVersion,
                    useStickyNode: true,
                });
                return stickyNodeClient;
            });
        }
    });
}
//# sourceMappingURL=blockchainClient.js.map